export default "__VITE_ASSET__kUv1268y__"